export default "__VITE_ASSET__h3iDrLi8__"